import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    // Si le hook est utilisé en dehors du ThemeProvider, cela indique une erreur
    throw new Error('useTheme doit être utilisé à l\'intérieur d\'un ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  // État pour stocker le thème actuel (par défaut 'light')
  const [theme, setTheme] = useState(() => {
    // Tente de récupérer le thème depuis le stockage local du navigateur
    const savedTheme = localStorage.getItem('theme');
    // Si un thème est sauvegardé, l'utilise, sinon vérifie la préférence système
    return savedTheme || (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
  });

  useEffect(() => {
    const root = window.document.documentElement;
    // Reset des classes
    root.classList.remove('light', 'dark');

    // Applique la classe actuelle
    root.classList.add(theme);

    // Sauvegarde
    localStorage.setItem('theme', theme);

    // Debug
    // console.log(`Thème appliqué : ${theme}`, root.classList);
  }, [theme]);
  // Fonction pour basculer entre les thèmes 'light' et 'dark'
  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  // Fournit le thème actuel et la fonction toggleTheme à tous les composants enfants
  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
